export function convertFormData(request: any): FormData {
  const formData = new FormData();

  for (const property in request) {
    if (request[property] !== null && request[property] !== undefined) {
      if (property === "files" && Array.isArray(request[property])) {
        // Manejar array de Files
        request[property].forEach((file: File, index: number) => {
          if (file instanceof File) {
            formData.append(`files[${index}]`, file);
          }
        });
      } else {
        // Manejar otros valores
        formData.append(property, request[property]);
      }
    }
  }

  return formData;
}
